/** Length of an audio/video file in seconds via the browser's metadata parser; undefined when unknown. */
export async function readMediaDurationSeconds(
  file: File,
  tag: 'video' | 'audio',
): Promise<number | undefined> {
  if (typeof document === 'undefined' || typeof URL.createObjectURL !== 'function')
    return undefined;
  return new Promise((resolve) => {
    const url = URL.createObjectURL(file);
    const media = document.createElement(tag);
    const finish = (value: number | undefined) => {
      media.removeAttribute('src');
      URL.revokeObjectURL(url);
      resolve(value);
    };
    media.preload = 'metadata';
    media.onloadedmetadata = () =>
      finish(Number.isFinite(media.duration) ? media.duration : undefined);
    media.onerror = () => finish(undefined);
    media.src = url;
  });
}
